var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('div',{staticClass:"bodyHeight"},[_c('loginModule'),_c('registerModule'),_c('FindPassword'),_c('ModifyPassword'),_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }